<template>
  <v-row>
    <v-col cols="12">
      <h3 class="font-weight-regular mb-3">Filtrar por</h3>

      <v-form @keyup.native.enter="load()">
        <v-row justify="start">
          <v-col cols="12" md="4">
            <v-text-field dense label="Empresa" v-model="dataset.filter.name" outlined></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-select dense :items="dataset.districts" label="Comarca" placeholder="Selecione uma Comarca"
              v-model="dataset.filter.district" item-value="id" item-text="name" outlined hide-details="auto"></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select dense :items="dataset.states" label="UF" placeholder="Selecione um UF"
              v-model="dataset.filter.state" item-value="id" item-text="name" outlined hide-details="auto"></v-select>
          </v-col>

          <v-col md="2" class=" text-uppercase text-right">
            <v-btn color="secondary" class="findButton-filter" @click="load()">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-row justify="space-between" class="pt-10 px-4 mb-2">
        <h3 class="font-weight-bold">Empresa</h3>
        <h3 class="font-weight-bold">Litisconsórcio</h3>
      </v-row>

      <v-list>
        <template v-if="!dataset.loading && dataset.clients.length">
          <v-menu
            v-for="(item, index) in dataset.clients"
            :key="item.id || index"
            v-model="item.actionsOpen"
            offset-y
            left
            transition="slide-y-transition"
            content-class="case-action-menu"
            min-width="240"
          >
            <template v-slot:activator="{ on, attrs }">
              <button
                type="button"
                class="case-list-trigger mb-2"
                :class="{ 'case-list-trigger--active': item.actionsOpen }"
                v-bind="attrs"
                v-on="on"
              >
                <v-col class="pa-0">
                  <v-divider class="primary"></v-divider>
                  <v-list-item class="d-flex align-center px-4">
                    <v-list-item-avatar>
                      <v-avatar :size="40">
                        <img :src="'https://ui-avatars.com/api/?background=7E55AB&color=fff&name=' + item.name" />
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content class="case-company-content">
                      <v-list-item-title class="text-uppercase font-weight-medium mediumGray--text">
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content class="text-right case-group-content">
                      <v-list-item-title v-if="item.companies && item.companies.length" class="company-group-summary">
                        {{ item.companies.map(company => company.name).join(', ') }}
                      </v-list-item-title>
                      <v-list-item-title v-else class="company-group-empty">-</v-list-item-title>
                    </v-list-item-content>
                    <v-icon
                      small
                      color="mediumGray"
                      class="case-menu-chevron ml-3"
                      :class="{ 'case-menu-chevron--open': item.actionsOpen }"
                    >
                      mdi-chevron-down
                    </v-icon>
                  </v-list-item>
                </v-col>
              </button>
            </template>

            <v-list dense class="case-action-list py-2">
              <v-list-item @click="navigateToDetails(item.id)">
                <v-list-item-icon class="mr-3">
                  <v-icon small color="primary">mdi-arrow-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">Abrir caso</v-list-item-title>
                  <v-list-item-subtitle>Continuar nesta aba</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                :href="caseDetailsHref(item.id)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon small color="primary">mdi-open-in-new</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">Abrir em nova aba</v-list-item-title>
                  <v-list-item-subtitle>Manter esta lista aberta</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else-if="!dataset.loading && !dataset.clients.length">
          <v-divider class="primary"></v-divider>
          <div class="pa-0 my-2">
            <span>Nenhuma empresa encontrada</span>
          </div>
        </template>
        <template v-else-if="dataset.loading">
          <v-divider class="primary"></v-divider>
          <div class="pa-0 my-2">
            <span>Buscando...</span>
          </div>
        </template>
        <v-divider class="primary"></v-divider>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import object from '@/common/util/object'
import axios from 'axios'
import statesList from "@/common/data/states-list.data"

export default {
  name: 'FilterComponent',

  props: {
    type: null
  },

  data() {
    return {
      dataset: {
        clients: [],
        districts: [],
        states: [{ id: "", name: "Todos" }, ...statesList],
        filter: {
          name: '',
          district: '',
          state: ''
        },
        options: {
          page: 1,
          itemsPerPage: 50,
          sortBy: ['name'],
          sortDesc: [false]
        },
        count: 0,
        loading: false
      }
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    async loadData() {
      await this.loadDistricts()
      await this.load()
    },

    getInitial(name) {
      return name ? name.charAt(0).toUpperCase() : '';
    },

    async loadDistricts() {
      try {
        const result = await axios.get(`/api/districts`, {
          params: { limit: 100000 }
        })
        this.dataset.districts = [{ id: "", name: "Todas" }, ...result.data.content.data]

      } catch (error) {
      
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      }
    },

    async load() {
      if (!this.type) return;

      let search = Object.fromEntries(Object.entries(this.dataset.filter).filter(([_, v]) => v));
      search = !object.isEmpty(search) ? search : {};
      search.type = this.type;

      this.dataset.loading = true;

      try {
        const result = await axios.get('/api/clients', {
          params: { limit: 10000, search: search }
        });

        const sortedClients = result.data.content.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(item => ({ ...item, actionsOpen: false }));

        this.dataset.clients = sortedClients;
        this.dataset.count = result.data.count;
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.loading = false;
      }
    },


    async navigateToDetails(id) {
      await this.$router.push({ name: 'CasesDetails', params: { id } });
    },

    caseDetailsHref(id) {
      return this.$router.resolve({ name: 'CasesDetails', params: { id } }).href;
    },
  }
}
</script>

<style scoped >
.findButton-filter {
  margin-right: 0px !important;
  margin-top: 1px !important;
  font-size: 18px !important;
  width: 150px;
  height: 40px !important;
  color: white !important;
  background-color: #009986 !important;
  transition: background-color 0.3s ease;

  @media (max-width: 600px) {
    width: 100%;
  }
}

.findButton:hover {
  background-color: #0077cc !important;
}

.v-list-item-avatar span {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

.company-group-summary {
  color: #666;
  font-size: 0.875rem;
  line-height: 1.3;
  white-space: normal;
}

.company-group-empty {
  color: #999;
  font-size: 0.875rem;
}

.case-list-trigger {
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  padding: 0;
  text-align: left;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
}

.case-list-trigger:hover,
.case-list-trigger:focus-visible,
.case-list-trigger--active {
  background: rgba(126, 85, 171, 0.08);
  outline: none;
}

.case-list-trigger:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(126, 85, 171, 0.45);
}

.case-menu-chevron {
  flex: 0 0 auto;
  transition: transform 0.2s ease;
}

.case-menu-chevron--open {
  transform: rotate(180deg);
}

::v-deep .case-action-menu {
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(31, 27, 48, 0.16);
}

::v-deep .case-action-list .v-list-item {
  min-height: 54px;
}

::v-deep .case-action-list .v-list-item:hover {
  background: rgba(126, 85, 171, 0.08);
}

@media (max-width: 600px) {
  .case-list-trigger .v-list-item {
    align-items: flex-start;
    flex-wrap: wrap;
    padding-bottom: 12px;
    padding-top: 12px;
  }

  .case-company-content,
  .case-group-content {
    flex: 1 1 calc(100% - 72px);
  }

  .case-group-content {
    margin-left: 64px;
    padding-top: 0;
    text-align: left !important;
  }

  .case-menu-chevron {
    position: absolute;
    right: 16px;
    top: 26px;
  }
}
</style>
